import { LabelType, Options } from '@angular-slider/ngx-slider';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsFacade, addFullStop } from '@piqet-angular/data';
import {
  AFactorMethodTypeEnum,
  CustomModalService,
  FileUploadResult,
  FileUploadComponent,
  projectsPlaceholder,
} from '@piqet-angular/shared';
import { cloneDeep } from 'lodash';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { GridCellDropdownComponent } from '../grid-cell-dropdown/grid-cell-dropdown.component';
import { GridNewAddProjectSliderComponent } from '../grid-new-add-project-slider/grid-new-add-project-slider.component';
import { noWhitespaceValidator } from 'libs/shared/src/lib/service/helper.service';
import { TitleCasePipe } from '@angular/common';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-new-my-projects',
  templateUrl: './new-my-projects.component.html',
  styleUrls: ['./new-my-projects.component.scss'],
  providers: [TitleCasePipe],
})
export class NewMyProjectsComponent {
  @ViewChild(FileUploadComponent) fileUploadComponent!: FileUploadComponent;
  projectsPlaceholder = projectsPlaceholder;
  modalLabel: any;
  myProjectData: any;
  myProjectForm!: FormGroup;
  submitted!: boolean;
  isShowCusurrencyField = true;
  shareItems: any;
  projectStatusList: any;
  regionItems: any;
  packageAccountedProducts: any;
  selectCountry: any;
  currencyItems: any;
  selectCheckBox = false;
  selectedFiles: string | null = null;
  selectOrganization: any;
  fileBase64: string | null = null;
  defaultRegionItems: any;
  materialItems: any;
  isHideDropDown = false;
  isShowTeamList = false;
  processColumnDef: any;
  teamList: any;
  organizationlist: any;
  errorNotification!: string;
  isShowDefalutSettings = false;
  disableSubmit = false;
  selectedDropDownValue: any;
  setOrganizationValue: any;
  headerBtn = 'Add row';
  // headerBtn = '<img class="fa fa-plus" width="60" height="60" src="./assets/icons/add-record.svg">';
  headerBtnName = 'myNewAddProject';
  departmentValue: any;
  productFamilyValue: any;
  productClass: any;
  applyToAll = false;
  isImageValid = true;
  currencyItem: any;
  disableSlider: boolean = false;
  aFactorMethodType = AFactorMethodTypeEnum;
  @Output() saveNewMyProjectEvent = new EventEmitter<any>();
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    GridNewAddProjectSliderComponent: GridNewAddProjectSliderComponent,
    dropdownRendered: GridCellDropdownComponent,
  };

  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return value + '%';
        case LabelType.High:
          return value + '%';
        default:
          return value + '%';
      }
    },
  };

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    public projectFacade: ProjectsFacade,
    private swalService: SwalService,
    private spinnerService: NgxSpinnerService,
    private toaster: ToastrService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.myProjectData = this.modal?.modalService?.config?.initialState?.['newMyProjects'];
    this.isHideDropDown =
      this.modal?.modalService?.config?.initialState?.['pathName'] == 'admin-projects'
        ? true
        : false;
    this.processColumnDef = this.modal?.modalService?.config?.initialState?.['processColDef'];
    this.shareItems = this.myProjectData.shareItems;
    this.projectStatusList = this.myProjectData.projectStatusList;
    this.regionItems = this.myProjectData.regionItems;
    this.packageAccountedProducts = this.myProjectData.packageAccountedProducts;
    this.currencyItems = this.myProjectData.currencyItems;
    this.defaultRegionItems = this.myProjectData.defaultRegionItems;
    this.defaultRegionItems = this.defaultRegionItems;
    this.materialItems = this.myProjectData.materialItems;
    this.teamList = this.myProjectData.projectTeamList;
    this.organizationlist = this.myProjectData.organizationItems;
    this.departmentValue = this.myProjectData.productDepartmentItems;
    this.productFamilyValue = this.myProjectData.productFamilyItems;
    this.productClass = this.myProjectData.productClassItems;
    this.organizatioListFunction();
  }

  ngOnInit() {
    this.projectFacade.clearDefaultMaterial();
    this.myProjectForm = this.formBuilder.group({
      projectName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(100)]],
      projectNameForReport: [
        '',
        [Validators.required, noWhitespaceValidator, Validators.maxLength(300)],
      ],
      share: [null, Validators.required],
      team: [null],
      status: [this.myProjectData.statusId || null, Validators.required],
      country: [null],
      productDepartment: [null],
      productFamily: [null],
      productClassForCategory: [null],
      packageProduct: [null],
      organizationName: [null],
      defaultCountry: [null, Validators.required],
      currency: [null],
      description: [''],
      recycleContent: [50],
      material: [null],
      recycledCredit: [null],
    });
    this.setCurrency();
    this.setFormData();
    this.selectedDropDownValue = this.selectOrganization;
    this.setOrganizationValue = this.selectOrganization;
    this.projectFacade.defalutMaterialProjectList$.subscribe((data: any) => {
      this.checkValidation(data);
    });
  }

  getProjectname(value: any) {
    this.myProjectForm.controls['projectNameForReport'].setValue(value);
  }
  showMoreFields() {
    this.isShowCusurrencyField = !this.isShowCusurrencyField;
  }

  defalutCountry(selectCountry: any) {
    if (this.myProjectForm.controls['defaultCountry']?.value?.id) {
      const data = selectCountry.find((data: any) => {
        if (data.id == this.myProjectForm.controls['defaultCountry']?.value.id) {
          return true;
        }
      });
      if (!data) {
        this.myProjectForm.controls['defaultCountry'].setValue(null);
      }
    }
    this.selectCountry = selectCountry.length == 0 ? this.defaultRegionItems : selectCountry;
  }

  async setCurrency() {
    await this.myProjectData.currencyItems?.map((data: any) => {
      if (data.id == 1) {
        return (this.currencyItem = data);
      }
    });
  }

  showDeafultSettings() {
    this.isShowDefalutSettings = !this.isShowDefalutSettings;
  }

  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForCountry(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.myProjectData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }

  setFormData() {
    this.myProjectForm.patchValue({
      organizationName: this.selectOrganization,
      currency: this.currencyItem,
      recycledCredit: this.aFactorMethodType[1],
    });
  }

  alertConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Are you sure you want to change the organization? if you are change the organization than energy process data will be lost.'
      )
      .then(confirmed => {
        if (confirmed) {
          this.setOrganizationValue = data;
          this.selectedDropDownValue = data;
        } else {
          this.setOrganizationValue = this.selectedDropDownValue;
        }
      });
  }

  selectValue(event: any) {
    this.alertConfirmation(event);
  }

  onClear(defalutMaterialProjectList: any) {
    this.disableSlider = false;
    defalutMaterialProjectList = defalutMaterialProjectList.map((x: any) => ({
      ...x,
      recycledCreditId: 3,
      range: this.myProjectForm.controls['recycleContent'].value,
    }));
    this.projectFacade.newMyProjectAction(defalutMaterialProjectList, 'edit');
  }

  updateRange(event: any, defalutMaterialProjectList: any) {
    this.applyToAll = false;
    this.disableSlider = event.name !== 'Custom';
    if (event.id == 1) {
      this.myProjectForm.patchValue({ recycleContent: 20 });
    } else if (event.id == 2) {
      this.myProjectForm.patchValue({ recycleContent: 50 });
    }
    defalutMaterialProjectList = defalutMaterialProjectList.map((x: any) => ({
      ...x,
      recycledCreditId: this.myProjectForm.controls['recycledCredit'].value?.id,
      range: this.myProjectForm.controls['recycleContent'].value,
    }));
    this.projectFacade.newMyProjectAction(defalutMaterialProjectList, 'edit');
  }

  onClose() {
    this.modal.close();
    this.projectFacade.clearDefaultMaterial();
  }

  selectTeam(data: any) {
    this.isShowTeamList = data.name == 'One of my team' ? true : false;
    if (this.isShowTeamList) {
      this.myProjectForm.controls['team'].setValidators([Validators.required]);
    } else {
      this.myProjectForm.controls['team'].clearValidators();
    }
    this.myProjectForm.controls['team'].updateValueAndValidity();
  }

  onFileSelected(result: FileUploadResult) {
    this.selectedFiles = result.fileName;
    this.fileBase64 = result.fileBase64;
    this.isImageValid = result.isValid;
  }

  checkValidation(defalutMaterialProjectList: any): void {
    const isValidate =
      defalutMaterialProjectList.find((x: any) => !x.hasOwnProperty('materialId')) ||
      !defalutMaterialProjectList.find((x: any) => x.materialId) ||
      defalutMaterialProjectList.some((x: any) => {
        if (x.materialId == null) {
          return true;
        } else {
          return false;
        }
      });
    if (isValidate) {
      this.errorNotification =
        'Please fill all the mandatory information to proceed further in the process.';
      this.disableSubmit = true;
    } else {
      const res: any[] = [];
      defalutMaterialProjectList.map((item: any) => {
        if (!this.errorNotification) {
          const existItem = res.find(
            x => x.materialId == item.materialId && x.amount == item.amount
          );
          if (existItem) {
            this.errorNotification =
              'Material is already exist, please select other material to proceed further.';
            this.disableSubmit = true;
          } else {
            res.push(item);
            this.errorNotification = '';
            this.disableSubmit = false;
          }
        }
      });
    }
    if (defalutMaterialProjectList?.length === 0) {
      this.errorNotification = '';
      this.disableSubmit = false;
    }
    this.processColumnDef = cloneDeep(this.processColumnDef);
    this.processColumnDef[this.processColumnDef.length - 1].cellRendererParams['disableSubmit'] =
      this.disableSubmit;
    this.processColumnDef[0].cellRendererParams['defalutMaterialProjectList'] = this.materialItems;
    this.processColumnDef[1].cellRendererParams['recycledCreditsList'] =
      this.myProjectData.recycledCreditsList;
  }

  inlineDataEditEvent(record: any) {
    if (record[2] === 'myNewAddProject') {
      this.projectFacade.newMyProjectAction(record[1], 'edit', record[3]);
    }
  }

  applyToAllSlider(defalutMaterialProjectList: any, isApply: boolean, recycledCredit?: any) {
    if (isApply) {
      defalutMaterialProjectList = defalutMaterialProjectList.map((x: any) => ({
        ...x,
        recycledCreditId: recycledCredit.id,
        range: this.myProjectForm.controls['recycleContent'].value,
      }));
      this.projectFacade.newMyProjectAction(defalutMaterialProjectList, 'edit');
    }
  }
  changeRuralValue(data: any) {
    this.applyToAll = false;
  }

  onFileRemove() {
    this.selectedFiles = null;
    this.fileBase64 = null;
    this.isImageValid = true;

    // Reset the file upload component
    if (this.fileUploadComponent) {
      this.fileUploadComponent.reset();
    }

    this.toaster.success('Image has been deleted');
  }

  onSave(defalutMaterialProjectList: any) {
    this.submitted = true;
    if (
      !this.myProjectForm.valid ||
      (this.isShowTeamList && !this.myProjectForm.controls['team'].value)
    ) {
      return;
    }
    const countriesId = this.myProjectForm.controls['country'].value?.map((x: any) => {
      return x.id;
    });
    const convertedArray = defalutMaterialProjectList.map((k: any) => ({
      materialId: k.materialId,
      range: k.range,
      recycledCreditId: k.recycledCreditId,
    }));
    const projecPayload = {
      projectId: this.myProjectData.projectId,
      projectName: this.myProjectForm.controls['projectName'].value,
      shortProjectName: this.myProjectForm.controls['projectNameForReport'].value,
      shareId: this.myProjectForm.controls['share'].value.id,
      statusId: this.myProjectData.statusId,
      organizationId:
        this.myProjectForm.controls['organizationName'].value?.id ||
        this.myProjectData.organizationId,
      currencyId: this.myProjectForm.controls['currency'].value?.id,
      countryId: this.myProjectForm.controls['defaultCountry'].value.id,
      countryIds: countriesId,
      productClassId: this.myProjectForm.controls['productClassForCategory'].value?.id,
      productFamilyId: this.myProjectForm.controls['productFamily'].value?.id,
      productDepartmentId: this.myProjectForm.controls['productDepartment'].value?.id,
      teamId: this.myProjectForm.controls['team'].value?.id,
      isTurnOffCost: !this.selectCheckBox,
      Description: addFullStop(this.myProjectForm.controls['description'].value),
      specificWasteMaterialItems: convertedArray,
      ProjectFileName: this.selectedFiles || null,
      ProjectImage: this.fileBase64 || null,
      PackageAccountedProductId: 3,
      allocationforRecycling: this.myProjectForm.controls['recycleContent'].value,
      recycledCreditId: this.myProjectForm.controls['recycledCredit'].value?.id,
    };

    this.saveNewMyProjectEvent.emit(projecPayload);
  }
}
